<!-- ============================================================== -->
<!-- Topbar header - style you can find in pages.scss -->
<!-- ============================================================== -->
<header class="topbar">
    <nav class="navbar top-navbar navbar-expand-md navbar-light">
        <!-- ============================================================== -->
        <!-- Logo -->
        <!-- ============================================================== -->
        <div class="navbar-header">
            <a class="navbar-brand"
               href="./">
                <!-- Logo icon --><b>
                    <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
                    <!-- Dark Logo icon -->
                    <img src="./assets/images/logo-icon.png"
                         alt="inicio"
                         class="dark-logo" />
                    <!-- Light Logo icon -->
                    <img src="./assets/images/logo-light-icon.png"
                         alt="inicio"
                         class="light-logo" />
                </b>
                <!--End Logo icon -->
                <!-- Logo text --><span>
                    <!-- dark Logo text -->
                    <img src="./assets/images/logo-text.png"
                         alt="inicio"
                         class="dark-logo" />
                    <!-- Light Logo text -->
                    <img src="./assets/images/logo-light-text.png"
                         class="light-logo"
                         alt="inicio" /></span> </a>
        </div>
        <!-- ============================================================== -->
        <!-- End Logo -->
        <!-- ============================================================== -->

        <div class="navbar-collapse">
            <!-- ============================================================== -->
            <!-- toggle and nav items -->
            <!-- ============================================================== -->
            <ul class="navbar-nav mr-auto">
                <!-- This is  -->
                <li class="nav-item">
                    <a id="menuTgl"
                       class="nav-link nav-toggler hidden-md-up waves-effect waves-dark"
                       href="javascript:void(0)">
                        <i class="fa-solid fa-bars"></i>
                    </a>
                </li>
                <li class="nav-item"> <a class="nav-link sidebartoggler hidden-sm-down waves-effect waves-dark"
                       href="javascript:void(0)"><i class="fa-solid fa-bars"></i></a> </li>
                <li class="nav-item hidden-sm-down"></li>



                <!-- badges de totales  -->

                <!-- totales Pedidos -->
                <li class="nav-item">
                    <ng-container *ngIf="cronTotalesSrv.totales?.pedidosSinCamp>0; else NO_pedidosSinCamp">
                        <a routerLink="/panel/campanya_new"
                           class="badge badge-pill badge-info text-white badge-totales"
                           title="Cargar campañas con {{cronTotalesSrv.totales?.pedidosSinCamp}} pedidos">
                            {{ cronTotalesSrv.totales?.pedidosSinCamp }} Pedidos pendientes
                        </a>
                    </ng-container>
                    <ng-template #NO_pedidosSinCamp>
                        <span class="badge badge-pill badge-muted badge-totales"
                              title="No hay pedidos pendientes">
                            0 Pedidos pendientes
                        </span>
                    </ng-template>
                </li>

                <!-- totales Entradas -->
                <li class="nav-item ml-2">
                    <ng-container *ngIf="cronTotalesSrv.totales?.entradasPendientes>0; else NO_entradasPendientes">
                        <a routerLink="/panel/entradas_lista"
                           class="badge badge-pill badge-info text-white badge-totales"
                           title="Abrir entradas pendientes">
                            {{ cronTotalesSrv.totales?.entradasPendientes }} Entradas pendientes
                        </a>
                    </ng-container>
                    <ng-template #NO_entradasPendientes>
                        <span class="badge badge-pill badge-muted badge-totales"
                              title="No hay entradas pendientes">
                            0 Entradas pendientes
                        </span>
                    </ng-template>
                </li>

                <!-- pedidosAccionPendiente -->
                <li class="nav-item ml-2">
                    <ng-container *ngIf="cronTotalesSrv.totales?.pedidosAccionPendiente >0; else NO_pedidosAccionPendiente">
                        <a routerLink="/panel/pedidos_lista/A"
                           class="badge badge-pill badge-warning text-white badge-totales"
                           title="Abrir pedidos con Acciones pendientes">
                            {{ cronTotalesSrv.totales?.pedidosAccionPendiente }} Acciones pendientes
                        </a>
                    </ng-container>
                    <ng-template #NO_pedidosAccionPendiente>
                        <span class="badge badge-pill badge-muted badge-totales"
                              title="No hay pedidos con Acciones pendientes">
                            0 Acciones pendientes
                        </span>
                    </ng-template>
                </li>

                <!-- Tiempo restante inactividad si faltan menos de 10 minutos -->
                <li *ngIf="tiempoRestante > 0 && tiempoRestante < 600000"
                    class="nav-item ml-2">
                    <span class="badge badge-pill badge-danger text-white badge-totales"
                          title="Tiempo restante antes de desconexión automática">
                        <i class="fa-solid fa-clock mr-2"></i> Desconexión en: {{ tiempoRestante | msToHms }}
                    </span>
                </li>


            </ul>
            <!-- ============================================================== -->
            <!-- User profile and search -->
            <!-- ============================================================== -->
            <ul class="navbar-nav my-lg-0">


                <!-- ============================================================== -->
                <!-- Comment -->
                <!-- ============================================================== -->

                <!-- ============================================================== -->
                <!-- End Comment -->
                <!-- ============================================================== -->

                <!-- ============================================================== -->
                <!-- Messages -->
                <!-- ============================================================== -->

                <!-- 
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle waves-effect waves-dark"
                       href=""
                       id="2"
                       data-toggle="dropdown"
                       aria-haspopup="true"
                       aria-expanded="false">
                        <i class="mdi mdi-email"></i>
                        <div class="notify">
                            <span class="heartbit"></span>
                            <span class="point"></span>
                        </div>
                    </a>
                    <div class="dropdown-menu mailbox dropdown-menu-right animated fadeIn"
                         aria-labelledby="2">
                        <ul>
                            <li>
                                <div class="drop-title">Tienes 4 mensajes nuevos</div>
                            </li>
                            <li>
                                <div class="message-center">
                                    
                                    <a href="#">
                                        <div class="user-img">
                                            <img src="./assets/images/users/gls_2.jpg"
                                                 alt="user"
                                                 class="img-circle">
                                            <span class="profile-status online pull-right"></span>
                                        </div>
                                        <div class="mail-contnet">
                                            <h5>CRM Hospitalet</h5>
                                            <span class="mail-desc">Almacen 01, ocupación al 98%</span>
                                            <span class="time">9:30 AM</span>
                                        </div>
                                    </a>
                                    

                                    <a href="#">
                                        <div class="user-img">
                                            <img src="./assets/images/users/gls_2.jpg"
                                                 alt="user"
                                                 class="img-circle">
                                            <span class="profile-status busy pull-right"></span>
                                        </div>
                                        <div class="mail-contnet">
                                            <h5>Oleada pendiente</h5>
                                            <span class="mail-desc">Preparación oleada 35987 Pendiente</span>
                                            <span class="time">9:10 AM</span>
                                        </div>
                                    </a>
                                    

                                    <a href="#">
                                        <div class="user-img">
                                            <img src="./assets/images/users/diotroni.png"
                                                 alt="user"
                                                 class="img-circle">
                                            <span class="profile-status away pull-right"></span>
                                        </div>
                                        <div class="mail-contnet">
                                            <h5>Oleada pendiente</h5>
                                            <span class="mail-desc">Preparación oleada 25344 Pendiente</span>
                                            <span class="time">9:10 AM</span>
                                        </div>
                                    </a>
                                    

                                    <a href="#">
                                        <div class="user-img">
                                            <img src="./assets/images/users/diotroni.png"
                                                 alt="user"
                                                 class="img-circle">
                                            <span class="profile-status offline pull-right"></span>
                                        </div>
                                        <div class="mail-contnet">
                                            <h5>CRM Hospitalet</h5>
                                            <span class="mail-desc">Dejar playa libre, entrada Jansen</span>
                                            <span class="time">9:02 AM</span>
                                        </div>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <a class="nav-link text-center"
                                   href="javascript:void(0);">
                                    <strong>Ver todos </strong>
                                    <i class="fa fa-angle-right"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li> 
                -->
                <!-- ============================================================== -->
                <!-- End Messages -->
                <!-- ============================================================== -->


                <li class="nav-item dropdown">
                    <span>{{entorno}}</span>
                </li>


                <!-- ============================================================== -->
                <!-- Language -->
                <!-- ============================================================== -->
                <!-- <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle waves-effect waves-dark"
                       href=""
                       data-toggle="dropdown"
                       aria-haspopup="true"
                       aria-expanded="false">
                        <i class="fa-solid fa-warehouse"></i> Hospitalet
                    </a>
                    <div class="dropdown-menu dropdown-menu-right animated fadeIn">
                        <a class="dropdown-item"
                           href="javascript:void(0);">
                            <i class="fa fa-warehouse"></i> Almacén 2
                        </a>
                        <a class="dropdown-item"
                           href="javascript:void(0);">
                            <i class="fa fa-warehouse"></i> Almacén 3
                        </a>
                        <a class="dropdown-item"
                           href="javascript:void(0);">
                            <i class="fa fa-warehouse"></i> Almacén 4
                        </a>
                    </div>
                </li> -->
                <!-- ============================================================== -->
                <!-- Profile -->
                <!-- ============================================================== -->
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle waves-effect waves-dark"
                       href=""
                       data-toggle="dropdown"
                       aria-haspopup="true"
                       aria-expanded="false"><img [src]="getUserFoto()"
                             alt="usuario"
                             class="profile-pic" /></a>
                    <div class="dropdown-menu dropdown-menu-right animated fadeIn">
                        <ul class="dropdown-user">
                            <li>
                                <div class="dw-user-box">
                                    <div class="u-img">
                                        <img [src]="getUserFoto()"
                                             alt="usuario">
                                    </div>
                                    <div class="u-text">
                                        <h4>{{usuarioSrv.userdata.nombre | slice:0:15}}</h4>
                                        <p class="text-muted">{{usuarioSrv.userdata.rol}}</p>
                                        <a routerLink="./usr_perfil"
                                           class="btn btn-rounded btn-danger btn-sm">
                                            Ver Perfil
                                        </a>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="u-text">
                                    <h6 *ngIf="usuarioSrv.userdata.timestamp"
                                        class="m-2">Última conexión hace {{usuarioSrv.userdata.timestamp! | friendlyTimestamp}}</h6>
                                </div>
                            </li>
                            <li role="separator"
                                class="divider"></li>
                            <li>
                                <a class="pointer"
                                   (click)="openChangePasswordModal(usuarioSrv.userdata)">
                                    <i class="fa fa-key"></i> Cambiar Contraseña</a>
                            </li>
                            <li><a routerLink="config"><i class="fa fa-cog"></i> Configurar App</a></li>
                            <li role="separator"
                                class="divider"></li>
                            <li><a (click)="logOut()"
                                   class="pointer">
                                    <i class="fa fa-power-off text-danger"></i> Desconectar
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</header>
<!-- ============================================================== -->
<!-- End Topbar header -->
<!-- ============================================================== -->